import * as React from 'react';

export const PlayIcon = ({ width = 33, height = 39, fill = "#1E1E1E", ...props }) => {
  return (
    <svg width="33" height="39" viewBox="0 0 33 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M33 19.5009C33.0012 20.0102 32.8707 20.5112 32.6209 20.9551C32.3712 21.399 32.0109 21.7707 31.575 22.0341L4.56 38.5603C4.10454 38.8392 3.58288 38.9915 3.0489 39.0014C2.51492 39.0112 1.98798 38.8784 1.5225 38.6166C1.06146 38.3588 0.677393 37.9828 0.409807 37.5274C0.142221 37.072 0.000770358 36.5535 0 36.0253V2.97656C0.000770358 2.44835 0.142221 1.92987 0.409807 1.47444C0.677393 1.01902 1.06146 0.64309 1.5225 0.385311C1.98798 0.123464 2.51492 -0.00937412 3.0489 0.000514399C3.58288 0.0104029 4.10454 0.16266 4.56 0.441561L31.575 16.9678C32.0109 17.2312 32.3712 17.6029 32.6209 18.0468C32.8707 18.4907 33.0012 18.9916 33 19.5009Z"
        fill={fill}/>
    </svg>
  );
};
